export const apiUrl = " https://tbr.resimator.fi:4430";